<template>
  <modal
    :modal-id="modalId"
    :title="modalTitle"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
  >
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="selectedUrl ? `crud/${inputs.id}` : `crud`"
      >
        <div class="form-group row align-items-center">
          <label for="inputs_name" class="col-sm-3 mb-0">
            {{ $t("title") }}
          </label>
          <app-input
            id="title"
            class="col-sm-9"
            type="text"
            v-model="inputs.category_name"
            :required="true"
          />
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin";
import { ModalMixin } from "../../../../../app/Mixins/ModalMixin";
import { axiosPost } from "../../../../Helpers/AxiosHelper";
import {
  TASK_CATEGORY_STORE,
  TASK_CATEGORY_UPDATE,
} from "../../../../Config/ApiUrl";

export default {
  name: "AddModal",
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
  },
  data() {
    return {
      preloader: false,
      inputs: {},
      modalId: "demo-add-edit-Modal",
      modalTitle: this.$t("add"),
    };
  },
  created() {
    if (this.selectedUrl) {
      this.modalTitle = this.$t("edit");
      this.preloader = true;
    }
  },
  methods: {
    submit() {
      if (this.modalTitle == "Edit") {
        axiosPost(TASK_CATEGORY_UPDATE, this.inputs)
          .then((res) => {
            
            // this.modalId = false;
            this.$toastr.s(res.data.message);
            this.$hub.$emit("reload-" + this.tableId);
            // $("#demo-add-edit-Modal").hide();
            this.closeModal();
          })
          .catch((error) => {
            
          });
      } else {
        axiosPost(TASK_CATEGORY_STORE, this.inputs)
          .then((res) => {
            
            // this.modalId = false;
            this.$toastr.s(res.data.message);
            this.$hub.$emit("reload-" + this.tableId);
            // $("#demo-add-edit-Modal").hide();
            this.closeModal();
          })
          .catch((error) => {
            
          });
      }
      // this.save(this.inputs);
    },
    afterSuccess(res) {
      this.$toastr.s(response.data.message);
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      if (response.data.phone) this.phone = response.data.phone;
      this.inputs = response.data;
      this.preloader = false;
    },
  },
};
</script>
